import { render } from "./Penguatkuasaan.vue?vue&type=template&id=dc7018ee"
import script from "./Penguatkuasaan.vue?vue&type=script&lang=js"
export * from "./Penguatkuasaan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__